import { ExternalLinkBlock, InternalLinkBlock, QuickLinksBlock } from "graphql/generated-types";

import Chevron from "@/icons/chevron.svg";

type LinkTypes = InternalLinkBlock | ExternalLinkBlock;

const QuickLinks = ({ block: { title, links } }: { block: QuickLinksBlock }) => {
	const blockLinks = links as LinkTypes[];
	return (
		<div>
			{title && <h3 className="block-title">{title}</h3>}
			<div className="flex flex-col-reverse gap-8 lg:flex-row lg:gap-14">
				{blockLinks &&
					blockLinks.map((block) => {
						return (
							<a
								key={block.id!}
								href={block.href}
								className="border-border hover:bg-blue group flex items-center gap-3 rounded-lg border px-7 py-4 align-middle text-base font-medium transition-colors hover:text-white"
							>
								{block.text}
								<Chevron className={"text-cyan h-5 transition-transform group-hover:translate-x-1"} />
							</a>
						);
					})}
			</div>
		</div>
	);
};

export default QuickLinks;
